function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M336.33 142.251l386.39 516.64-388.83 420.05h87.51l340.42-367.76 275.05 367.76h297.8l-408.13-545.7 361.92-390.99h-87.51l-313.51 338.7-253.31-338.7h-297.8zm128.69 64.46h136.81l604.13 807.76h-136.81l-604.13-807.76z"
});

function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 1668.56 1221.19"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0iMCAwIDE2NjguNTYgMTIyMS4xOSI+CiAgPHBhdGggZD0ibTMzNi4zMyAxNDIuMjUxIDM4Ni4zOSA1MTYuNjQtMzg4LjgzIDQyMC4wNWg4Ny41MWwzNDAuNDItMzY3Ljc2IDI3NS4wNSAzNjcuNzZoMjk3LjhsLTQwOC4xMy01NDUuNyAzNjEuOTItMzkwLjk5aC04Ny41MWwtMzEzLjUxIDMzOC43LTI1My4zMS0zMzguN2gtMjk3Ljh6bTEyOC42OSA2NC40NmgxMzYuODFsNjA0LjEzIDgwNy43NmgtMTM2LjgxbC02MDQuMTMtODA3Ljc2eiIvPgo8L3N2Zz4K";
export { SvgIconTwitter as ReactComponent };